import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // Default: localStorage for web
import apiServices from './apiServices'; 
import productReducer from './slices/productSlice'; 
import searchStringReducer from './slices/searchStringSlice';
import searchedProductReducer from './slices/searchedProductSlice'; 
import expireReducer from 'redux-persist-transform-expire';

// Persist Config for product slice
const persistConfig = {
  key: 'product',        
  storage,               
  whitelist: ['cart', 'selectedProduct', 'selectedProductStore', 'compare', 'wishList'],  
  transforms: [
    expireReducer('cart', { expireSeconds: 2592000, expiredState: [] }),  // 30 days expiration
    expireReducer('selectedProduct', { expireSeconds: 2592000, expiredState: null }),  
    expireReducer('selectedProductStore', { expireSeconds: 2592000, expiredState: null }),  
    expireReducer('compare', { expireSeconds: 2592000, expiredState: [] }),  
    expireReducer('wishList', { expireSeconds: 2592000, expiredState: [] }),  
  ],
};

// Persist Config for searchedProduct slice
const searchedProductPersistConfig = {
  key: 'searchedProduct',
  storage,
  whitelist: ['searchedProduct'],
  transforms: [
    expireReducer('searchedProduct', { expireSeconds: 200, expiredState: [] }), // 
  ],
};

// Create persisted reducers for each slice
const persistedProductReducer = persistReducer(persistConfig, productReducer);
const persistedSearchedProductReducer = persistReducer(searchedProductPersistConfig, searchedProductReducer); 

// Configure the Redux store
const store = configureStore({
  reducer: {
    [apiServices.reducerPath]: apiServices.reducer,
    product: persistedProductReducer, 
    searchedProduct: persistedSearchedProductReducer, 
    searchString: searchStringReducer, // Adding the searchString slice to the store

  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, 
    }).concat(apiServices.middleware),
});

// Create the persistor
const persistor = persistStore(store);

export { store, persistor };
